module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Loyal to the Sky")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "CSS_1.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "d14e135"
    }
  }, [_c('p', {
    attrs: {
      "id": "d7e2958"
    }
  }, [_c('br'), _vm._v(" You come and go. The doors swing closed "), _c('br'), _vm._v(" ever more gently, almost without a shudder. "), _c('br'), _vm._v(" Of all who move through the quiet houses, "), _c('br'), _vm._v(" you are the quietest."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e3138"
    }
  }, [_c('br'), _vm._v(" We become so accustomed to you, "), _c('br'), _vm._v(" we no longer look up "), _c('br'), _vm._v(" when your shadow falls over the book we are reading "), _c('br'), _vm._v(" and makes it glow. For all things "), _c('br'), _vm._v(" sing you: at times "), _c('br'), _vm._v(" we just hear them more clearly."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e3368"
    }
  }, [_c('br'), _vm._v(" Often when I imagine you "), _c('br'), _vm._v(" your wholeness cascades into many shapes. "), _c('br'), _vm._v(" You run like a herd of luminous deer "), _c('br'), _vm._v(" and I am dark, I am forest."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e3548"
    }
  }, [_c('br'), _vm._v(" You are a wheel at which I stand, "), _c('br'), _vm._v(" whose dark spokes sometimes catch me up, "), _c('br'), _vm._v(" revolve me nearer to the center. "), _c('br'), _vm._v(" Then all the work I put my hand to "), _c('br'), _vm._v(" widens from turn to turn."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "d7e3778"
    }
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_vm._v("I, ")]), _vm._v("45 from "), _c('i', [_vm._v("Rilke’s Book of Hours: Love Poems to God;")]), _c('br'), _vm._v(" translation by Joanna Macy and Anita Barrows")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da469140","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/abc.vue
// module id = 75
// module chunks = 0